import React from 'react';
import { Facebook, Instagram } from 'lucide-react';

const Social = () => {
  const socialLinks = [
    {
      icon: Facebook,
      name: 'Facebook',
      url: 'https://www.facebook.com/share/1FrDLFBT8x/?mibextid=wwXIfr',
      color: 'hover:text-blue-600',
      bgColor: 'hover:bg-blue-50',
    },
    {
      icon: Instagram,
      name: 'Instagram',
      url: 'https://www.instagram.com/romanforseat2?igsh=MW1xNzBrcnRsMmlwMw%3D%3D&utm_source=qr',
      color: 'hover:text-pink-600',
      bgColor: 'hover:bg-pink-50',
    },
  ];

  return (
    <section id="social" className="relative py-20 md:py-32 overflow-hidden">
      {/* Elegant Purple Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-purple-50/40 to-purple-100/60"></div>
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: `linear-gradient(135deg, rgba(124, 58, 237, 0.05) 0%, transparent 50%),
                         radial-gradient(circle at 30% 70%, rgba(139, 92, 246, 0.08) 0%, transparent 60%)`
      }}></div>
      
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Stay Connected
          </h2>
          <div className="w-24 h-1.5 bg-purple-700 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600">
            Follow our campaign on social media for the latest updates and news
          </p>
        </div>

        {/* Social Media Icons */}
        <div className="flex justify-center gap-6">
          {socialLinks.map((social, index) => {
            const Icon = social.icon;
            return (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`w-20 h-20 rounded-full bg-white shadow-lg ${social.bgColor} flex items-center justify-center text-gray-700 ${social.color} transition-all duration-300 hover:scale-110 hover:shadow-2xl`}
                aria-label={social.name}
              >
                <Icon className="w-9 h-9" />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Social;
